import React from 'react';
import Table from '../../common/TableFinancial';
import { connect } from 'react-redux';
import { REDUCER_NAME, changeSortState } from '../reducer';
import Const from './Const';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectDataTopForeignTradeByTicker;

const widths = {};

const schema = listColumn =>
  Object.keys(listColumn).map((item, index) => {
    const key = listColumn[item];
    if (key === 'ticker') widths[key] = 100;
  });
function TableFinancial(props) {
  const { listId, sortState, changeSortState } = props;

  return (
    <Table
      sortState={sortState}
      onSort={changeSortState}
      listId={listId}
      getDataFromRedux={getDataFromRedux}
      hideColumns={Const.listHideColumn}
      listColumns={Const.listColumn}
      i18nTitleKey="topVolume.financial.financialHeader"
      schema={schema(Const.listColumn)}
      widths={widths}
    />
  );
}

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataTopForeignTradeTicker,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableFinancial);
